import { format } from "date-fns-tz";
function localTimeToUTC(timeStr: string) {
  const today = new Date();

  // Split the time string
  const [hours, minutes] = timeStr.split(":").map(Number);

  const localDate = new Date(
    today.getFullYear(),
    today.getMonth(),
    today.getDate(),
    hours,
    minutes
  );

  return localDate.toISOString();
}

export const getUTCTimeString = (timeStr: string) => {
  const utcDate = new Date(localTimeToUTC(timeStr));
  const hours = String(utcDate.getUTCHours()).padStart(2, "0");
  const minutes = String(utcDate.getUTCMinutes()).padStart(2, "0");
  return `${hours}:${minutes}`;
};

export const extractTimeFromDateString = (dateString: string): string => {
  const date = new Date(dateString);
  return `${String(date.getHours()).padStart(2, "0")}:${String(
    date.getMinutes()
  ).padStart(2, "0")}`;
};

export const displayTime = (timeStr: string) => {
  return format(new Date(timeStr), "hh:mm a", { timeZone: "America/Halifax" });
};

export const formatDateToISO = (dateString: string) => {
  if (!dateString) return "";
  try {
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return ""; // Invalid date

    // Format as YYYY-MM-DD
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  } catch (error) {
    console.error("Error formatting date:", error);
    return "";
  }
};

export const calculateDaysRemaining = (startDate: string, endDate: string) => {
  const start = new Date(startDate);
  const end = new Date(endDate);
  const now = new Date();

  if (start > now) {
    return "Membership not started yet";
  }
  if (end < now) {
    return "Membership has ended";
  }

  const diffTime = end.getTime() - now.getTime();

  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

  return `${diffDays} day${diffDays !== 1 ? "s" : ""} remaining`;
};

export const passSelectedDate = (date: string, time?: string) => {
  const newDate = time ? new Date(`${date} ${time}`) : new Date(date);
  const year = newDate.getFullYear();
  const month = newDate.getMonth() + 1;
  const day = newDate.getDate();
  return `${year}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
};
